/** Hooks TanStack Query pour la recherche de badges */

import { useMutation } from '@tanstack/react-query';

const API_URL = import.meta.env.VITE_API_URL;

export interface BadgeLookupResult {
  badge_uid: string;
  found: boolean;
  employee_id: number | null;
  employee_name: string | null;
  department: string | null;
  site_name: string | null;
  is_active: boolean | null;
}

function getHeaders(): HeadersInit {
  const token = localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    ...(token && { Authorization: `Bearer ${token}` }),
  };
}

/** Lookup d'un badge par son UID. */
export function useLookupBadge() {
  return useMutation<BadgeLookupResult, Error, string>({
    mutationFn: async (uid: string) => {
      const res = await fetch(`${API_URL}/api/badges/lookup?uid=${encodeURIComponent(uid)}`, {
        headers: getHeaders(),
      });
      if (!res.ok) {
        const body = await res.json().catch(() => ({}));
        throw new Error(body.detail || `Erreur ${res.status}`);
      }
      return res.json();
    },
  });
}
